import React from "react";

import { ForumTopics } from "@/mk2/apps/forum/containers/ForumTopics/ForumTopics";
import ForumTopicsPage, { Props } from "@/mk2/apps/forum/containers/ForumTopics/ForumTopicsPage";
import { TopicEntity } from "@/mk2/apps/forum/schemas";
import { forumPostNewInTopicUrl, forumPostNewUrl } from "@/mk2/apps/forum/urls";
import { url } from "@/mk2/helpers/urls";
import { SELECT_TOPIC, SEO_TITLE_FORUM_THREAD_NEW_CATEGORY } from "@/mk/autogenerated/translations/PostCreateSelectTopicPage.6a9cced3e0defcfd9913cc9ea9d947f4";
import { isAuthenticated } from "@/mk/bazaar/common/userUtils";

export default class PostCreateSelectTopicPage extends ForumTopicsPage {
    protected createTopic: boolean = false;

    public getPermissionRequired(props: Props): boolean {
        const { requestUser } = props;
        return isAuthenticated(requestUser);
    }

    public getMetaTitle(props: Props): string {
        return SEO_TITLE_FORUM_THREAD_NEW_CATEGORY;
    }

    public getHeaderTitle(props: Props): string {
        return SELECT_TOPIC;
    }

    public render(props: Props): false | JSX.Element {
        return <ForumTopics {...props} itemToTopicUrl={this.itemToTopicUrl} />;
    }

    public hasHeaderBackButton(props: Props): boolean {
        return true;
    }

    public getDefaultBackPath(props: Props): string | any {
        return forumPostNewUrl;
    }

    public getHeaderTabs(props: Props): JSX.Element[] | null {
        // Hide tabs in creating mode
        return null;
    }

    public getHeaderRight(props: Props): React.ReactElement {
        // Hide action buttons when creating
        return null;
    }

    private itemToTopicUrl = (item: TopicEntity) =>
        url(forumPostNewInTopicUrl, { categorySlug: item.category.slug, topicSlug: item.slug });
}
